var render = function render(){var _vm=this,_c=_vm._self._c;return _c('countTo',{staticStyle:{"font-size":"18px","font-family":"PingFangSC-Medium, PingFang SC","font-weight":"500","color":"#c4f0ff"},attrs:{"startVal":0,"endVal":parseInt(_vm.num),"duration":3000,"decimals":_vm.decimals}})
}
var staticRenderFns = []

export { render, staticRenderFns }